import React from 'react';
import WidgetChart from './WidgetChart';
import WidgetAvatar from './WidgetAvatar';
import WidgetText from './WidgetText';

const WidgetContent = ({
  loading,
  error,
  chartPrompt,
  chartHTML,
  isTableChart,
  rawSqlResponse,
  hasAvatar,
  textResult,
  prompt,
  onAvatarPlay,
  isPlaying,
  isProcessing,
  setIsPlaying,
  tool
}) => {
  const getImage = () => {
    if (!textResult) return null;

    const content = textResult.toLowerCase();
    if (content.includes('birthday')) {
      return '/birthday.jpg';
    } else if (content.includes('cruise')) {
      return '/cruise.jpg';
    }else if (content.includes('meeting')) {
      return '/minutes.jpg';
    } else if (content.includes('travel')) {
      return '/travel.jpg';
    } else if (content.includes('college')) {
      return '/college.jpg';
    } else if (content.includes('anniversary')) {
      return '/anniversary.jpg';
    } 
    return null;
  }

  const renderShimmerEffect = () => (
    <div className="p-2.5 w-full">
      {chartPrompt !== null && (
        <div className="h-[150px] mb-4 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
      )}
      <div className="h-[15px] mb-2.5 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
      <div className="h-[15px] mb-2.5 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
      <div className="h-[15px] mb-2.5 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
    </div>
  );

  if (loading && tool !== 'Transcript Analysis') {
    return renderShimmerEffect();
  }

  if (tool === 'Transcript Analysis' && !textResult && !loading) {
    return (
      <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
        <p className="text-sm font-medium text-gray-400">Awaiting transcript</p>
        <p className="text-xs text-gray-300 mt-1">Record or upload a transcript to generate analysis</p>
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500 p-3 bg-red-50 rounded-lg">{error}</div>;
  }

  if (chartPrompt !== null) {
    return (
      <WidgetChart
        chartHTML={chartHTML}
        isTableChart={isTableChart}
        rawSqlResponse={rawSqlResponse}
      />
    );
  }

  if (hasAvatar) {
    return (
      <WidgetAvatar
        textResult={textResult}
        prompt={prompt}
        onAvatarPlay={onAvatarPlay}
        isPlaying={isPlaying}
        isProcessing={isProcessing}
        setIsPlaying={setIsPlaying}
      />
    );
  }

  // Get the image path
  const imagePath = getImage();

  return (
    <>
      {imagePath && (
        <div style={{
          width: '100%',
          height: '200px',
          marginBottom: '10px',
          overflow: 'hidden',
          borderRadius: '4px'
        }}>
          <img
            src={imagePath}
            alt="img"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>
      )}
      <WidgetText textResult={textResult} prompt={prompt} />
    </>
  );
};

export default WidgetContent;